export default __webpack_public_path__ + "static/media/happy-school-img3.e1bdb77c.png";